import { Navigate, Outlet } from 'react-router-dom'
import { tokenStorage } from '@/lib/auth/tokenStorage'

/**
 * Wraps guest-only routes (login). Redirects to /dashboard if already authenticated.
 */
export function GuestRoute() {
  if (tokenStorage.hasTokens()) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
